module.exports = __webpack_public_path__ + "img/email.9d54e28c.png";